module.exports = __webpack_public_path__ + "static/im-775ed2e1f9fc9fcf10d6c42c5ede1ee2.svg";